<template>
<div>
  <ui-basic />
</div>
</template>

<script>
import UiBasic from '@/components/ui-basic'

export default {
  name: 'v-home',
  components: {
    UiBasic
  },
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/v-home.vue